import React, {
  useEffect, useContext, useState, useCallback,
} from 'react';
import { UserSessionContext } from 'components/UserSession';
import connectSingleSessionService from 'network/singleUserSessionClient';
import KickCallbackModal from './modals/concurrentSession/KickCallbackModal';
import ForceLoginModal from './modals/concurrentSession/ForceLoginModal';

const ConcurrentSessionTracker = () => {
  const [openKickCallbackModal, setOpenKickCallbackModal] = useState(false);
  const [openForceLoginModal, setOpenForceLoginModal] = useState(false);
  const { userSession, setUserSession } = useContext(UserSessionContext);

  const retryLoginWithForce = useCallback(() => {
    connectSingleSessionService(userSession.authToken, true);
    setOpenForceLoginModal(false);
  }, [userSession.authToken]);

  const redirectToLanding = useCallback(() => {
    setUserSession({});
    setOpenKickCallbackModal(false);
    setOpenForceLoginModal(false);
  }, [setUserSession]);

  useEffect(() => {
    const kickCallbackListener = () => {
      setOpenKickCallbackModal(true);
      setTimeout(() => {
        redirectToLanding();
      }, 3000);
    };
    const otherDeviceLoggedInListener = () => {
      setOpenForceLoginModal(true);
    };
    window.addEventListener('kickCallback', kickCallbackListener);
    window.addEventListener('another device logged in', otherDeviceLoggedInListener);
    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('kickCallback', kickCallbackListener);
      window.removeEventListener('another device logged in', otherDeviceLoggedInListener);
    };
  }, [redirectToLanding, setUserSession, userSession]);

  return (
    <>
      <KickCallbackModal open={openKickCallbackModal} />
      <ForceLoginModal open={openForceLoginModal} onConfirm={retryLoginWithForce} onCancel={redirectToLanding} />
    </>
  );
};

export default ConcurrentSessionTracker;
